import { useState } from "react";
import { useNavigate } from "react-router-dom";
import semboller from "../data/semboller.json";
import YildizArkaplan from "../components/YildizArkaplan";

export default function FaldaSemboller() {
  const navigate = useNavigate();
  const [arama, setArama] = useState("");
  const [acikKart, setAcikKart] = useState(null);

  const filtreli = semboller.filter((s) => {
    const q = arama.toLowerCase();
    return (
      s.baslik?.toLowerCase().includes(q) ||
      s.kisa_anlam?.toLowerCase().includes(q)
    );
  });

  return (
    <div style={{
      minHeight: "100vh",
      background: "linear-gradient(180deg, #0a0718 0%, #110d24 40%, #0d0a1a 100%)",
      position: "relative",
      overflow: "hidden",
      fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
      maxWidth: 420,
      margin: "0 auto",
    }}>
      <style>{`
        * { box-sizing: border-box; margin: 0; padding: 0; }
        ::-webkit-scrollbar { display: none; }
        @keyframes kart-gir { from { opacity: 0; transform: translateY(14px); } to { opacity: 1; transform: translateY(0); } }
      `}</style>

      <YildizArkaplan />

      <div style={{ position: "relative", zIndex: 1, paddingBottom: 100 }}>

        {/* Header */}
        <div style={{ padding: "20px 16px 0", display: "flex", alignItems: "center", gap: 12 }}>
          <div
            onClick={() => navigate(-1)}
            style={{ width: 36, height: 36, borderRadius: "50%", background: "rgba(255,255,255,0.07)", border: "1px solid rgba(255,255,255,0.12)", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, cursor: "pointer", flexShrink: 0 }}
          >
            ‹
          </div>
          <div>
            <div style={{ fontSize: 18, fontWeight: 700, color: "#fff" }}>✦ Falda Semboller</div>
            <div style={{ fontSize: 11, color: "rgba(167,139,250,0.6)", marginTop: 2, letterSpacing: 1 }}>
              {semboller.length} sembol
            </div>
          </div>
        </div>

        {/* Arama */}
        <div style={{ padding: "14px 16px 0" }}>
          <div style={{ background: "linear-gradient(135deg, rgba(124,58,237,0.2), rgba(109,40,217,0.1))", border: "1px solid rgba(124,58,237,0.4)", borderRadius: 16, padding: 20, marginBottom: 20 }}>
            <div style={{ fontSize: 14, color: "#a78bfa", fontWeight: 600, marginBottom: 12 }}>🔍 Sembol Ara</div>
            <div style={{ position: "relative" }}>
              <span style={{ position: "absolute", left: 14, top: "50%", transform: "translateY(-50%)", fontSize: 16, pointerEvents: "none" }}>🔍</span>
              <input
                type="text"
                value={arama}
                onChange={(e) => setArama(e.target.value)}
                placeholder="Hangi sembolü gördün?"
                style={{
                  width: "100%",
                  background: "rgba(0,0,0,0.3)",
                  border: "1px solid rgba(124,58,237,0.5)",
                  borderRadius: 12,
                  padding: "14px 16px 14px 44px",
                  color: "#fff",
                  fontSize: 15,
                  outline: "none",
                  fontFamily: "'Trebuchet MS', Tahoma, sans-serif",
                  boxSizing: "border-box",
                }}
                onFocus={(e) => { e.target.style.border = "1px solid #7c3aed"; e.target.style.boxShadow = "0 0 0 3px rgba(124,58,237,0.2)"; }}
                onBlur={(e) => { e.target.style.border = "1px solid rgba(124,58,237,0.5)"; e.target.style.boxShadow = "none"; }}
              />
            </div>
            <div style={{ fontSize: 12, color: "rgba(167,139,250,0.6)", marginTop: 8, textAlign: "center" }}>✦ 100 kahve falı sembolü arasında ara</div>
          </div>
        </div>

        {/* Grid */}
        <div style={{ padding: "14px 16px 0", display: "flex", flexDirection: "column", gap: 10 }}>
          {filtreli.length === 0 ? (
            <div style={{ gridColumn: "1/-1", textAlign: "center", padding: "40px 0", color: "rgba(255,255,255,0.3)", fontSize: 14 }}>
              Sembol bulunamadı
            </div>
          ) : (
            filtreli.map((s, i) => {
              const acik = acikKart === s.id;
              return (
                <div
                  key={s.id}
                  style={{
                    borderRadius: 16,
                    background: "rgba(255,255,255,0.04)",
                    border: "1px solid rgba(167,139,250,0.18)",
                    padding: "18px 16px",
                    display: "flex",
                    flexDirection: "column",
                    gap: 6,
                    animation: "kart-gir 0.4s ease backwards",
                    animationDelay: `${Math.min(i, 10) * 40}ms`,
                  }}
                >
                  {/* Emoji + Başlık */}
                  <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                    <span style={{ fontSize: 24, lineHeight: 1 }}>{s.emoji}</span>
                    <span style={{ fontSize: 14, fontWeight: 700, color: "#fff", lineHeight: 1.3 }}>{s.baslik}</span>
                  </div>

                  {/* Anlam */}
                  <div style={{ fontSize: 13, color: "rgba(167,139,250,0.85)", lineHeight: 1.4 }}>
                    {s.kisa_anlam}
                  </div>

                  {/* Detay */}
                  <div
                    onClick={() => setAcikKart(acik ? null : s.id)}
                    style={{
                      fontSize: 13,
                      color: "rgba(255,255,255,0.4)",
                      lineHeight: 1.5,
                      overflow: "hidden",
                      display: "-webkit-box",
                      WebkitLineClamp: acik ? "unset" : 2,
                      WebkitBoxOrient: "vertical",
                      cursor: "pointer",
                    }}
                  >
                    {s.icerik}
                  </div>
                  {s.icerik?.length > 100 && (
                    <div
                      onClick={() => setAcikKart(acik ? null : s.id)}
                      style={{ fontSize: 12, color: "rgba(167,139,250,0.5)", cursor: "pointer" }}
                    >
                      {acik ? "▲ Kapat" : "▼ Devamını oku"}
                    </div>
                  )}

                  {/* Buton */}
                  <div
                    onClick={() => navigate("/falcilar?fal=kahve")}
                    style={{
                      marginTop: 4,
                      background: "rgba(139,92,246,0.15)",
                      border: "1px solid rgba(139,92,246,0.35)",
                      borderRadius: 10,
                      padding: "6px 10px",
                      fontSize: 11,
                      color: "rgba(167,139,250,0.9)",
                      fontWeight: 700,
                      cursor: "pointer",
                      textAlign: "center",
                    }}
                    onMouseDown={(e) => { e.currentTarget.style.opacity = "0.7"; }}
                    onMouseUp={(e) => { e.currentTarget.style.opacity = "1"; }}
                    onTouchStart={(e) => { e.currentTarget.style.opacity = "0.7"; }}
                    onTouchEnd={(e) => { e.currentTarget.style.opacity = "1"; }}
                  >
                    Falıma Bak →
                  </div>
                </div>
              );
            })
          )}
        </div>

      </div>
    </div>
  );
}
